/* globals jQuery */
import './jquery.flexslider.js';
import './jquery.fitvids.js';
import './jquery.accordion.js';
import './jquery.debounce.js';
import './responsive-nav.jquery.js';
import './map.js';

(($) => {

	//main hero slideshow
	$('.hero-caption.flexslider').flexslider({
		directionNav: false,
		slideshow: true,
		before: function(slider){
			//transition the background slidehsow to the corresponding slide
			$('.hero-bg.flexslider').flexslider(slider.animatingTo);
		}
	});
	//background slides for the hero slideshow
	$('.hero-bg.flexslider').flexslider({
		directionNav: false,
		controlNav: false,
		slideshow: false
	});

	// Make nav menu nice & responsive
	$('nav.main-nav').responsiveNav();

	// Responsive Videos
	$('.rtecontent').fitVids();

	// Accordions
	$('dl.accordion').accordion();

	// gallery flexslider
	$('.gallery-slideshow.flexslider').flexslider({
		controlNav: 'thumbnails'
	});

	$('.map').acfMap();

	//SHAPE MOVEMENT
	$(window).scroll(function(){

		var sh1 = $(window).scrollTop() / 7;
		$(".shape-move-up").css("transform", "translate3d(0," + -(sh1) + "px, 0)");

    	var sh2 = $(window).scrollTop() / 7;
    	$(".shape-move-down").css("transform", "translate3d(0," + (sh2) + "px, 0)");

    });

    $('.rtecontent a img').each(function(){
        $(this).parent("a").addClass("image-link");
    });

})(jQuery)
